// extracted by mini-css-extract-plugin
export var container = "SegmentedControl-module--container--09772";
export var input = "SegmentedControl-module--input--1f119";
export var lgBreak = "1200";
export var mdBreak = "992";
export var smBreak = "768";
export var xsBreak = "480";